import { render, staticRenderFns } from "./SummaryDetails.vue?vue&type=template&id=f04be29e&scoped=true"
import script from "./SummaryDetails.vue?vue&type=script&lang=js"
export * from "./SummaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SummaryDetails.vue?vue&type=style&index=0&id=f04be29e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04be29e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f04be29e')) {
      api.createRecord('f04be29e', component.options)
    } else {
      api.reload('f04be29e', component.options)
    }
    module.hot.accept("./SummaryDetails.vue?vue&type=template&id=f04be29e&scoped=true", function () {
      api.rerender('f04be29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/financials-agent/components/Balance/SummaryDetails.vue"
export default component.exports